

import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { MovementContext } from '../../context/movementContext/MovementContext';
import { clientsOrEntreprises, typeEnvois, wilayas } from '../../data';
import { getMovementDecharge, updateDecharge } from '../../context/movementContext/apiCalls';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import FormInput from '../../components/formInput/FormInput';
import FormRadio from '../../components/formRadio/FormRadio';
import FormTextArea from '../../components/formTextArea/FormTextArea';
import ImageLoader from '../../components/imageLoader/ImageLoader';
import PageSizeComponent from '../../components/pageSizeComponent/PageSizeComponent';
import TableComponent from '../../components/tableComponent/TableComponent';
import PaginationComponent from '../../components/paginationComponent/PaginationComponent';

export default function DetailDecharge() {
    const { page = 1, id } = useParams();
    const [pageSize, setPageSize] = useState(10);

    const { dispatch, movementDecharge, envoisDecharge, count: pages, countGlobal, isFetchingGetDecharge, errorGetDecharge, message, isFetchingUpdate, errorUpdate } = useContext(MovementContext);
    const [clientOrEntreprise, setClientOrEntreprise] = useState(clientsOrEntreprises[1]);
    const [entreprise, setEntreprise] = useState({ nom: "Choisir Entreprise", id: 0, });
    const [username, setUsername] = useState("");
    const [errorBox, setErrorBox] = useState("");

    const [globalMontant, setGlobalMontant] = useState(0);
    const [globalCount, setGlobalCount] = useState(0);
    const [motif, setMotif] = useState("");
    const [fileDecharge, setFileDecharge] = useState(null);

    useEffect(() => {
        getMovementDecharge(dispatch, pageSize, page, id);
    }, [id, pageSize, page, message])

    useEffect(() => {
        if (errorGetDecharge !== "") {
            setErrorBox(errorGetDecharge)
        }
        if (errorUpdate !== "") {
            setErrorBox(errorUpdate)
        }
    }, [errorGetDecharge, errorUpdate])

    useEffect(() => {
        if (!isFetchingGetDecharge) {
            if (envoisDecharge.length !== 0) {
                if (envoisDecharge[0]['Entreprise'] !== null) {
                    setClientOrEntreprise(clientsOrEntreprises[0]);
                    setEntreprise({ nom: envoisDecharge[0]['Entreprise']['nom'], id: envoisDecharge[0]['Entreprise']['id'] });
                } else {
                    setClientOrEntreprise(clientsOrEntreprises[1]);
                    setUsername(envoisDecharge[0]['User']['username']);
                }
            }
            if (Object.keys(movementDecharge).length !== 0) {
                setGlobalMontant(movementDecharge.montant);
                setGlobalCount(countGlobal);
                setMotif(movementDecharge.motif);
            }
        }
    }, [movementDecharge, envoisDecharge])

    const updateMovementDecharge = () =>{
        updateDecharge(dispatch, id, motif, fileDecharge);
    }
    const getTypeEnvoie = (type) => {
        if (type === 1) {
            return "a-accuse"
        } else if (type === 2) {
            return "s-accuse"
        } else if (type === 3) {
            return "pick-up"
        }
    }

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="movement" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Editer/Modifier un Déchargement :</span>
                </div>

                {errorBox && <ErrorComponent error={errorBox} />}

                {
                    isFetchingGetDecharge ? <LoadingComponent /> : (
                        <div className="content invoice" style={{ marginTop: '20px' }}>
                            <div className="box" style={{ marginBottom: '20px', pointerEvents: 'none' }}>
                                <div className="box-content">
                                    <FormRadio data={clientsOrEntreprises.filter(item=>item.id !== 1)} itemChoisir={clientOrEntreprise} setItemChoisir={setClientOrEntreprise} name='tab-client-entreprise' />
                                    {
                                        clientOrEntreprise.id === 1 ? (
                                            <DropDownComponent data={[{ nom: "Choisir Entreprise", id: 0 }]} itemChoisir={entreprise} setItemChoisir={setEntreprise} filter />
                                        ) : (
                                            <FormInput label='Username' itemInput={username} setItemInput={setUsername} auth />
                                        )
                                    }
                                </div>
                            </div>
                            <div className="box" style={{ marginBottom: '20px', minWidth: '550px', }}>
                                <div className="box-content">
                                    <FormInput label="Nombre d'Envoie" itemInput={globalCount} setItemInput={setGlobalCount} auth inactive muted />
                                    <FormInput label='Montant Global' itemInput={globalMontant} setItemInput={setGlobalMontant} auth inactive muted />
                                    <FormTextArea label='Description' itemInput={motif} setItemInput={setMotif} auth />
                                    <ImageLoader imageLabel={"Attacher Image"} fileDecharge={fileDecharge} setFileDecharge={setFileDecharge} imgUrl={movementDecharge.image} subPath='uploadDecharge' />
                                    <div className='button' onClick={updateMovementDecharge} style={isFetchingUpdate ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                        <span>
                                            {isFetchingUpdate ? "Modifier ..." : "Modifier"}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <PageSizeComponent pageSize={pageSize} setPageSize={setPageSize} itemLocation={`movements/decharge/${id}/detail`} />
                            <div className="content">
                                {
                                    <>
                                        <TableComponent headers={['Id', "Type d'Envoie", "Wilaya d'Arrivé", "Montant", "Date"]}>
                                            {
                                                envoisDecharge.map((element, index) => (
                                                    <tr key={index}>
                                                        <td>{element.id}</td>
                                                        <td>
                                                            <span className={`table-special-border ${getTypeEnvoie(element.typeEnvoie)}`}>{typeEnvois.filter(item => item.id === element.typeEnvoie)[0]['nom']}</span>
                                                        </td>
                                                        <td>{wilayas.filter(item => item.id == element.wilayaArrived)[0]['nom']}</td>
                                                        <td>{Number.parseFloat(element.montant).toFixed(2)}</td>
                                                        <td>{element.createdAt.slice(0, 10)}</td>
                                                    </tr>
                                                ))
                                            }
                                        </TableComponent>
                                        {
                                            (pages > 1) && (<PaginationComponent page={page} pages={pages} item={`movements/decharge/${id}/detail`} />)
                                        }
                                    </>
                                }
                            </div>
                        </div>
                    )
                }

            </div>
        </div>
    )
}
